import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-md-5 offset-md-1" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "member-id" }, " Member ID ", -1 /* HOISTED */)
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "group-name" }, " Group Name ", -1 /* HOISTED */)
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "group-id" }, " Group ID ", -1 /* HOISTED */)
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "relationship-to-insured" }, [
  /*#__PURE__*/_createTextVNode(" Relationship to Insured "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Relationship to Insured", -1 /* HOISTED */)
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "group-id" }, " Case Manager ", -1 /* HOISTED */)
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "employer-name" }, " Employer Name ", -1 /* HOISTED */)
const _hoisted_18 = { class: "col-12 col-md-5" }
const _hoisted_19 = {
  key: 0,
  class: "form-group"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "bill-as" }, " Bill As ", -1 /* HOISTED */)
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "deductible-amount" }, " Deductible Amount ", -1 /* HOISTED */)
const _hoisted_24 = { class: "form-group d-flex flex-row justify-content-between" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "has-deductible-met",
  class: "me-2"
}, " Deductible Met ", -1 /* HOISTED */)
const _hoisted_26 = {
  class: "btn-group btn-group-toggle",
  "data-bs-toggle": "buttons"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  hidden: "",
  name: "has-deductible-met",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Yes ")
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  hidden: "",
  name: "has-deductible-met",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" No ")
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "copay-amount" }, " Copay Amount ", -1 /* HOISTED */)
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "subs-first-name" }, [
  /*#__PURE__*/_createTextVNode(" Subscriber First Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_37 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "subs-last-name" }, [
  /*#__PURE__*/_createTextVNode(" Subscriber Last Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_40 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { for: "copay-amount" }, " Comments ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "member-id",
          type: "text",
          placeholder: "Enter Member ID",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payer.MemberId) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.MemberId]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "group-name",
          type: "text",
          placeholder: "Enter Group Name",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.payer.GroupName) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.GroupName]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "group-id",
          type: "text",
          placeholder: "Enter Group ID",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payer.GroupId) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.GroupId]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _withDirectives(_createElementVNode("select", {
          class: "form-select",
          name: "relationship-to-insured",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payer.RelationshipToInsured) = $event)),
          onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.payer.RelationshipToInsured.$touch && _ctx.v$.payer.RelationshipToInsured.$touch(...args)))
        }, [
          _hoisted_11,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.relationshipToInsuredEnum), ([key, value]) => {
            return (_openBlock(), _createElementBlock("option", {
              key: key,
              value: value.value
            }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_12))
          }), 128 /* KEYED_FRAGMENT */))
        ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelSelect, _ctx.payer.RelationshipToInsured]
        ]),
        (_ctx.v$.payer.RelationshipToInsured.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Relationship is required."))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "group-id",
          type: "text",
          placeholder: "Enter Case Manager",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.payer.CaseManager) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.CaseManager]
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "employer-name",
          type: "text",
          placeholder: "Enter Employer Name",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payer.EmployerName) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.EmployerName]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      (_ctx.payer.Type === _ctx.roomAndBoardTypeValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _hoisted_20,
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              name: "bill-as",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.payer.BillAsType) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.payerSequenceCodeEnum), ([key, value]) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: key,
                  value: value.value
                }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_21))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, _ctx.payer.BillAsType]
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "deductible-amount",
          type: "text",
          placeholder: "Enter Deductible Amount",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.payer.DeductibleAmount) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.DeductibleAmount],
          [_directive_number_only]
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", null, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("label", {
              class: _normalizeClass(`btn btn-outline-secondary ${_ctx.payer.DeductibleMet ? 'active' : ''}`),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.hasDeductibleMetChanged(true)))
            }, _hoisted_29, 2 /* CLASS */),
            _createElementVNode("label", {
              class: _normalizeClass(`btn btn-outline-secondary ${_ctx.payer.DeductibleMet ? '' : 'active'}`),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.hasDeductibleMetChanged(false)))
            }, _hoisted_32, 2 /* CLASS */)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "copay-amount",
          type: "text",
          placeholder: "Enter Copay Amount",
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.payer.CopayAmount) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.CopayAmount]
        ])
      ]),
      (_ctx.showSubscriberName)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                name: "subs-first-name",
                type: "text",
                placeholder: "Enter Subscriber First Name",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.payer.SubscriberFirstName) = $event)),
                onBlur: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.v$.payer.SubscriberFirstName.$touch && _ctx.v$.payer.SubscriberFirstName.$touch(...args)))
              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                [_vModelText, _ctx.payer.SubscriberFirstName]
              ]),
              (_ctx.v$.payer.SubscriberFirstName.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Subscriber First Name is required."))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                name: "subs-last-name",
                type: "text",
                placeholder: "Enter Subscriber Last Name",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.payer.SubscriberLastName) = $event)),
                onBlur: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.v$.payer.SubscriberLastName.$touch && _ctx.v$.payer.SubscriberLastName.$touch(...args)))
              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                [_vModelText, _ctx.payer.SubscriberLastName]
              ]),
              (_ctx.v$.payer.SubscriberLastName.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_40, "Subscriber Last Name is required."))
                : _createCommentVNode("v-if", true)
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_41, [
        _hoisted_42,
        _withDirectives(_createElementVNode("textarea", {
          class: "form-control",
          id: "comments",
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.payer.Comments) = $event)),
          rows: "4",
          maxlength: "300"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.Comments]
        ])
      ])
    ])
  ]))
}